import { IAllDebts } from '../context/BatchPaymentContext';
import { IDebts, IMandatoryDebt } from '../hooks/useDebts';

export const handleDebtsByType = (
  type: 'multas' | 'licenciamento' | 'ipva' | 'dpvat' | 'outros',
  debts: IMandatoryDebt[] | IDebts[] | IAllDebts[] | any[],
) => {
  return debts.filter((debt) => debt.type === type);
};

export const haveSameBatchId = (debts: IDebts[]) => {
  if (debts.length === 0) return false;
  const firstBatchId = debts[0].batchId;
  if (!firstBatchId) return false;
  return debts.every((debt) => debt.batchId === firstBatchId);
};

export const areAllConsultDatesToday = (debts: IDebts[]): boolean => {
  const today = new Date();

  return debts.every((debt) => {
    if (!debt.consultDate) return false;

    const consultDateObj = new Date(debt.consultDate);

    return (
      consultDateObj.getFullYear() === today.getFullYear() &&
      consultDateObj.getMonth() === today.getMonth() &&
      consultDateObj.getDate() === today.getDate()
    );
  });
};

export const filterBySelectedDebts = (data: {
  refetchedDebts: IDebts[];
  selectedDebts: IDebts[];
}): IDebts[] => {
  const { refetchedDebts, selectedDebts } = data;

  return refetchedDebts.filter((refetchedDebt) => {
    return selectedDebts.some((selectedDebt) => {
      const sameVehiclePlate =
        refetchedDebt.vehiclePlate === selectedDebt.vehiclePlate;
      const sameIssuer = refetchedDebt.issuer === selectedDebt.issuer;
      const sameType = refetchedDebt.type === selectedDebt.type;
      const sameConsultName =
        refetchedDebt.consultName === selectedDebt.consultName;
      const sameSubUser = refetchedDebt.subUser === selectedDebt.subUser;

      return (
        sameVehiclePlate &&
        sameIssuer &&
        sameType &&
        sameConsultName &&
        sameSubUser
      );
    });
  });
};

export const sumDebtsByTypeAndPlate = (
  type: string,
  plate: string,
  allDebts: IAllDebts[],
) => {
  return allDebts
    .filter((debt) => debt.plate === plate && debt.type === type)
    .reduce((acc, debt) => {
      return acc + debt.value;
    }, 0);
}

export const sumDebts = (data: { [key: string]: number | string }[], key: string) => {
  if (data && data.length > 0 && key in data[0]) {
    return data.reduce((acc, debts) => {
      return acc + Number(debts[key] ?? 0);
    }, 0);
  }
  return 0;
}
